<button class="button" (click)="onButtonClick()" [disabled]="isDisabled">
  {{ labelKey | translate }}
</button>
